/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Assistant_RequestInputs */

const cs_enum_assistant_request = /** @type {(inputs: Enum_Assistant_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Požadavek na asistenta`)
};

const en_enum_assistant_request = /** @type {(inputs: Enum_Assistant_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant request`)
};

/**
* | output |
* | --- |
* | "Assistant request" |
*
* @param {Enum_Assistant_RequestInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_assistant_request = /** @type {((inputs?: Enum_Assistant_RequestInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Assistant_RequestInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_assistant_request(inputs)
	return cs_enum_assistant_request(inputs)
});